import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useTranslation } from 'react-i18next';

// Components
import InputField from '../../../../../../atoms/InputField/InputField';
import YoutubePreview from '../../../../../../molecules/YoutubePreview/YoutubePreview';
import MediaPictures from '../../../Common/MediaPictures/MediaPictures';

function Medias({ formik }) {
  const { t } = useTranslation();

  return (
    <div>
      <MediaPictures formik={formik} withSlider />

      <h3 className="fs-20 m-b-25">{t('camps.marketing.sub.video')}</h3>

      <div className="input_max">
        <InputField
          id="videoUrl"
          name="videoUrl"
          value={formik.values.videoUrl}
          label={t('camps.marketing.form.videoUrl')}
          formik={{
            handleChange: formik.handleChange,
            handleBlur: formik.handleBlur,
          }}
          error={formik.errors?.videoUrl && formik.touched?.videoUrl ? formik.errors.videoUrl : null}
          full
        />
      </div>

      {formik.values.videoUrl ? (
        <div className="m-t-40">
          <YoutubePreview url={formik.values.videoUrl} />
        </div>
      ) : null}
    </div>
  );
}

Medias.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      videoUrl: PropTypes.string,
      mainImageMedia: PropTypes.string,
      sliderImageMedias: PropTypes.arrayOf(PropTypes.string),
    }),
    handleChange: PropTypes.func,
    setFieldValue: PropTypes.func,
    handleBlur: PropTypes.func,
    errors: PropTypes.shape({
      videoUrl: PropTypes.string,
    }),
    touched: PropTypes.shape({
      videoUrl: PropTypes.bool,
    }),
  }).isRequired,
};

export default Medias;
